import { ReactElement } from "react"
import { AlbumFoto } from "./downloadStrategies/downloadStrategies"
import styles from "./galerij.module.css"
import { Icon } from "./icons/Icon"

interface Props {
    fotos: (AlbumFoto | undefined)[]
    isFotosAanHetLaden: boolean
    laadMeerFotos?: () => void
}

export const Galerij = (props: Props): ReactElement => {
    const { fotos, isFotosAanHetLaden, laadMeerFotos } = props

    return (
        <div className={styles.main}>
            {fotos.length === 0 ? (
                <h1>Dit event bevat (nog) geen fotos</h1>
            ) : (
                <>
                    <h1>Tik op een fotostrip om alle foto's te bekijken</h1>
                    <div className={styles.grid}>
                        {fotos.map((foto, index) =>
                            foto ? (
                                <img key={foto.naam} src={foto.url} alt={foto.naam} onClick={() => window.location.assign(foto.detailUrl)} />
                            ) : (
                                <div className="laad-icoon" key={`laad-icoon-${index}`}>
                                    <Icon icon="spinner" />
                                </div>
                            )
                        )}
                    </div>
                    {!isFotosAanHetLaden && laadMeerFotos && (
                        <button disabled={isFotosAanHetLaden} onClick={laadMeerFotos}>
                            Laad meer...
                        </button>
                    )}
                </>
            )}
        </div>
    )
}
